import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  identity: {
    email: '',
    cif: ''
  },
  documentsRequired: null,
  saveDocuments: false,
  patternsCMS: null,
  legalConditions: null,
  errorMessage: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
